import { Form, Select, Typography } from "antd";
import { usePrevious } from "common/customHooks";
import { ActionStatus } from "common/enums";
import { showError } from "common/ToastNotifications";
import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Text } = Typography;
const { Option } = Select;

function SubscriptionSourceDataSetSelectFormItem({
    subscriptionId,
    getSubscriptionSourceDataSets,
    getSubscriptionSourceDataSetsAction,
    dataSets,
    formItemProps,
    onChange,
    disabled,
    defaultItem,
}) {
    const [fetchingDataSets, setFetchingDataSets] = useState(false);
    const previousGetSubscriptionSourceDataSetsAction = usePrevious(getSubscriptionSourceDataSetsAction);
    const [dataSetDict, setDataSetDict] = useState({});

    useEffect(() => {
        if (subscriptionId) {
            setFetchingDataSets(true);
            getSubscriptionSourceDataSets(subscriptionId);
        }
    }, [subscriptionId, getSubscriptionSourceDataSets]);

    useEffect(() => {
        const dataSetDict = {};
        if (dataSets && dataSets.length > 0) {
            for (let dataSet of dataSets) {
                dataSetDict[dataSet.dataSetId] = dataSet;
            }
        }
        setDataSetDict(dataSetDict);
    }, [dataSets]);

    useEffect(() => {
        if (getSubscriptionSourceDataSetsAction && getSubscriptionSourceDataSetsAction !== previousGetSubscriptionSourceDataSetsAction) {
            if (getSubscriptionSourceDataSetsAction.status === ActionStatus.FAILED) {
                if (getSubscriptionSourceDataSetsAction.code === "PERMISSION_DENIED") {
                    showError("Permission denied.");
                } else {
                    showError("Unable to retrieve datasets at this moment.");
                }
            }
            setFetchingDataSets(false);
        }
    }, [getSubscriptionSourceDataSetsAction, dataSets, previousGetSubscriptionSourceDataSetsAction]);

    const onDataSetChange = useCallback(
        (dataSetId) => {
            if (onChange && dataSetDict[dataSetId]) {
                onChange(dataSetId, dataSetDict[dataSetId]);
            }
        },
        [dataSetDict, onChange],
    );

    return (
        <Form.Item {...formItemProps}>
            <Select placeholder="Please select Dataset" loading={fetchingDataSets} onChange={onDataSetChange} disabled={disabled || !subscriptionId}>
                <>
                    {defaultItem && dataSets.findIndex((item) => item.dataSetId === defaultItem.dataSetId) === -1 && (
                        <Option key={defaultItem.dataSetId} value={defaultItem.dataSetId}>
                            {defaultItem.dataSetName}
                        </Option>
                    )}
                </>
                {dataSets.map((dataSet) => (
                    <Option key={dataSet.dataSetId} value={dataSet.dataSetId}>
                        {dataSet.dataSetName}
                    </Option>
                ))}
            </Select>
        </Form.Item>
    );
}

const mapStateToProps = (state, ownProps) => {
    return {
        getSubscriptionSourceDataSetsAction: state.dataSyndicationSubscription.getSubscriptionSourceDataSetsAction,
        dataSets: state.dataSyndicationSubscription.dataSets,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getSubscriptionSourceDataSets: (subscriptionId) => dispatch(actions.getSubscriptionSourceDataSetsRequest(subscriptionId)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubscriptionSourceDataSetSelectFormItem));
